import { http } from "@dashboard/common/http";
import { getEnvVar } from "@dashboard/common/utils";
import {
  DeliveryConfigurationData,
  EstimatedDeliveryTimes,
} from "../entities/delivery.entities";
import { normalizeDeliveryConfigurationData } from "../utils/delivery-create.utils";

const remoteConfigHeaders = () => ({
  "api-key-sumer": getEnvVar("REACT_APP_KEY_SP"),
  "Accept-Language": localStorage.getItem("i18nextLng") || "es",
});

export const fetchDeliveryConfigurationData =
  async (): Promise<DeliveryConfigurationData> => {
    const response = await http.get(
      "/api/ms/remote-config/country-data/delivery_configuration_data",
      { headers: remoteConfigHeaders() },
    );
    if (response.status !== 200) return { types: [], sizes: [] };
    const raw = response.data?.value ?? response.data ?? {};
    return normalizeDeliveryConfigurationData(raw);
  };

export const fetchEstimatedDeliveryTimes =
  async (): Promise<EstimatedDeliveryTimes> => {
    try {
      const response = await http.get(
        "/api/ms/remote-config/country-data/estimated_delivery_times",
        { headers: remoteConfigHeaders() },
      );
      return response.data?.value ?? response.data ?? {};
    } catch (error) {
      return {};
    }
  };
